import React from 'react';
import { Box, Tabs } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CustomTab from './CustomTab';
import { NAV_TABS } from '../constants';
import { useStyles } from '../styles/navigationTabStyles';

const NavigationTab = () => {
  const location = useLocation();
  const classes = useStyles();
  const acitveTab = NAV_TABS.findIndex((tab) => location?.pathname === tab.path);
  return (
    <Box className={classes.border}>
      <Tabs className={classes.rootTab} value={acitveTab}>
        {NAV_TABS.map((tab) => (
          <CustomTab key={tab.label} label={tab.label} to={`${tab.path}`} />
        ))}
      </Tabs>
    </Box>
  );
};

export default NavigationTab;
